import { Component, Input, OnInit } from '@angular/core';

import { CopyService } from '@amfam/shared/utility/shared-services';

@Component({
  selector: 'ds-next-steps',
  templateUrl: './next-steps.component.html',
  styleUrls: ['./next-steps.component.scss'],
  standalone: false
})
export class NextStepsComponent implements OnInit {
  @Input() isPolicyEnrolled: boolean;
  @Input() recentAction: string;
  @Input() emailId: string;
  @Input() policyState: string;

  emailIdProp: unknown;
  nextSteps = this.copyService.getCopy('billing.nextSteps');
  constructor(public copyService: CopyService) {}
  ngOnInit() {
    this.emailIdProp = {
      emailId: this.emailId
    };
  }
}
